module.exports = __webpack_public_path__ + "static/media/ic-close-red.d211fd04.svg";